import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';
import {
  ISearchSpsApiOauthIdUrlInjectionSite,
  ISpsApiOauthIdUrlInjectionSite,
} from './apiOauthIdUrlInjectionSite.model';

class SpsApiOauthIdUrlInjectionSiteService {
  ENDPOINT = '/sps-api-oauth-id-url-injection-site';

  public async searchSpsApiOauthIdUrlInjectionSite(
    searchParams?: ISearchSpsApiOauthIdUrlInjectionSite
  ): Promise<IApiResponse<ISearchResponse<ISpsApiOauthIdUrlInjectionSite>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  public async getSpsApiOauthIdUrlInjectionSiteById(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'GET' }).then((res) => {
      return res.data;
    });
  }

  public async saveSpsApiOauthIdUrlInjectionSite(
    data: ISpsApiOauthIdUrlInjectionSite
  ): Promise<any> {
    const { id, ...restData } = data;
    if (id > 0) {
      const url = `${this.ENDPOINT}/${id}`;
      return request({ url, method: 'PUT', data: restData }).then((res) => {
        return res.data;
      });
    } else {
      const url = `${this.ENDPOINT}`;
      return request({ url, method: 'POST', data: restData }).then((res) => {
        return res.data;
      });
    }
  }

  public async deleteSpsApiOauthIdUrlInjectionSite(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'DELETE' }).then((res) => {
      return res.data;
    });
  }

  public async exportExcelFile(searchParams?: ISearchSpsApiOauthIdUrlInjectionSite): Promise<any> {
    const url = `back-ground-processes/export-excel`;
    return request({
      url,
      method: 'POST',
      data: searchParams,
    }).then((res) => {
      return res;
    });
  }
}
export default new SpsApiOauthIdUrlInjectionSiteService();
